import { default as CustRouter } from './Router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AuthState from './context/auth/authState';



function App() {


  return (
    <div>
      <AuthState>
        <CustRouter />
        <ToastContainer />
      </AuthState>
    </div>
  );
}

export default App;
